<template>
  <div>
    <site-header></site-header>

    <main>
      <article :class="$style.post" v-if="post" class="wrap">
        <header :class="$style.header">
          <h1 :class="$style.title" v-html="post.title.rendered"></h1>
        </header>
        <div :class="$style.body">
          <div v-html="post.content.rendered" :class="$style.content"></div>
          <p :class="$style.meta">{{ postedAt }}</p>
        </div>
      </article>
    </main>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import fecha from 'fecha';
  import he from 'he';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'post',

    components: {
      SiteHeader,
      Loader,
    },

    data() {
      return {
        loading: true,
        post: null,
      };
    },

    head: {
      title() {
        return {
          inner: (this.post) ? he.decode(this.post.title.rendered) : 'Loading',
        };
      },
    },

    mounted() {
      axios.get(`/api/posts/${this.$route.params.slug}`).then((response) => {
        if (response.data.length) {
          this.loading = false;
          this.post = response.data[0];
          this.$emit('updateHead');
        } else {
          this.$router.push('/404');
        }
      }).catch(() => {
        this.$router.push('/404');
      });
    },

    computed: {
      postedAt() {
        return fecha.format(new Date(this.post.date_gmt), '[Posted at] HH:MM [on] DD.MM.YYYY');
      },
    },
  };
</script>

<style module lang="postcss">
  .post {
    padding: 1rem;
    max-width: 50em;

    @media (width >= 50em) {
      padding: 1rem 4rem 2rem;
    }
  }

  .header {
    margin-bottom: 2rem;
    text-align: center;
  }

  .title {
    font-size: 3rem;
    line-height: 1.25;
    font-weight: 600;
  }

  .body {
    & p, li {
      font-size: 1.1rem;
      line-height: 1.5;
    }

    & p,
    & ul,
    & ol {
      margin-bottom: 1.7rem;
    }

    & li:not(:last-child) {
      margin-bottom: 0.875rem;
    }

    & p,
    & li {
      font-size: 1.1rem;
      margin-bottom: 1.7rem;
      line-height: 1.5;
    }

    & .meta {
      margin: 0;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.2;
      letter-spacing: 0.05rem;
      text-indent: 0.05rem;
      text-transform: uppercase;
      color: #444;
    }

    & figure,
    & :global(.wp-caption) {
      margin: 0 0 1.7rem;
      max-width: 100%;
    }

    & img,
    & iframe,
    & :global(.wp-caption) {
      max-width: 100%;
      height: auto;
    }

    & figcaption,
    & :global(.wp-caption-text) {
      margin-top: 0.75rem;
      color: #999;
      font-size: 0.875rem;
    }

    & :global(.alignleft) {
      @media (width >= 50em) {
        float: left;
        margin-right: 2rem;
        margin-bottom: 2rem;
      }
    }

    & :global(.aligncenter) {
      display: block;
      margin-right: auto;
      margin-left: auto;
    }

    & :global(.alignright) {
      @media (width >= 50em) {
        float: right;
        margin-bottom: 2rem;
        margin-left: 2rem;
      }
    }

    & [rel~=attachment] {
      display: block;
      padding: 1.7rem 0 0;
      border: none;
    }
  }

  .content {
    margin-bottom: 1.7rem;
  }
</style>



// WEBPACK FOOTER //
// Post.vue?f5ff4336